import styled from 'styled-components'
import L from '../L'
import Type from '../Type'

const StyledCollectionCard = styled(L).attrs({
  position: 'relative',
  width: '100%',
  selectable: true,
})`
  padding-top: 60%;
  overflow: hidden;
  border-radius: ${props => props.theme.globals.borderRadiusLarge}px;
  transition: ${props => props.theme.mixins.transition(['box-shadow'], '.4s')};

  &:hover {
    box-shadow: ${props => props.theme.globals.depth[700]};
  }

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(13, 13, 13, 0.2), rgba(13, 13, 13, 1));
  }
`

const CollectionDot = styled.div`
    ${props => props.theme.typography.h4}
    font-weight: 800;
    display: flex;
    align-items: center;
    position: absolute;
    top: 10px;
    right: 10px;
    background: #FFFFFF;
    opacity: .9;
    border-radius: 20px;
    height: 33px;
    min-width: 33px;
    white-space: nowrap;
    overflow: hidden;
  
    &:before {
      content: '${props => props.totalSims}';
      width: 19px;
      text-align: center;
      position: absolute;
      left: 7px;
      display: flex;
      justify-content: center;
    }
  
    &:after {
      content: '${props => (props.totalSims <= 1 ? `Simulation` : `Simulations`)}';
      padding-left: ${props => (props.totalSims >= 10 ? `29px` : `24px`)};
      padding-right: 0;
      max-width: 0;
      opacity: 0;
      transition: ${props => props.theme.mixins.transition(['opacity', 'max-width', 'padding-right'], '.4s')};
    }
    ${StyledCollectionCard}:hover &:after {
      padding-right: 10px;
      max-width: 150px;
      opacity: 1;
    }
  `

const CollectionTitle = styled(Type).attrs({
  variant: 'titleMedium',
})`
  display: inline;
  background-image: linear-gradient(
    ${props => `0deg, ${props.theme.palette.primary.main} 0%, ${props.theme.palette.primary.main} 100%`}
  );
  background-repeat: no-repeat;
  background-position: 0px 85%;
  background-size: 0% 7px;
  transition: ${props => props.theme.mixins.transition(['background-size'], '.4s')};

  ${StyledCollectionCard}:hover & {
    background-size: 100% 7px;
  }
`

const StyledCollectionGrid = styled(L).attrs({
  display: 'grid',
  columns: {
    xx: 'repeat(auto-fit, minmax(185px, 100%))',
    xs: 'repeat(auto-fit, minmax(185px, calc((100% - 20px * 1) / 2)))',
    sm: 'repeat(auto-fit, minmax(185px, calc((100% - 20px * 2) / 3)))',
    md: 'repeat(auto-fit, minmax(185px, calc((100% - 20px * 3) / 4)))',
    lg: 'repeat(auto-fit, minmax(185px, calc((100% - 20px * 4) / 5)))',
  },
  gap: 2,
  jc: 'flex-start',
})``

export { StyledCollectionGrid, CollectionTitle, CollectionDot, StyledCollectionCard }
